import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { LayoutComponent } from './layout.component';
import { AuthService } from '../services/auth.service';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { User } from '../services/interfaces';
import { ScopeService } from '../services/scope.service';
import { MobileSizeService } from './../services/mobile-size.service';
import { MenuItem } from 'primeng/api';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router, Scroll } from '@angular/router';


@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  styleUrls: ['./app.topbar.component.scss']
})
export class AppTopBarComponent implements OnInit, OnDestroy {
  userSub: Subscription;
  activeUser: User = { first_name: '', last_name: '', thumb_name: null };
  isMobile = false;
  isMobileMenuActive = false;

  blankImage = '/assets/osto/defaultUser.png';

  model: any[];
  adminModel: any[];
  displayWidth: BehaviorSubject<number> = new BehaviorSubject<number>(window.innerWidth);
  routerSub: Subscription;
  viewAsUserNameSub: Subscription;
  viewAsUserName: string;

  isBtnActive = {
    '/dashboard': false,
    '/supplies': false,
    '/usages': false,
    '/outputs': false,
    '/supplies/suppliers': false,
    '/supplies/orders': false,
    '/settings': false,
  }

  isAdminBtnActive = {
    '/admin/users': false,
    '/admin/mastersupplies': false,
    '/admin/mastercareprovider': false,
    '/admin/pushnotifications': false,
    '/admin/bulk-emails': false,
    '/admin/pushtopics': false,
    '/admin/release-notes': false,
    '/admin/sponsors': false,
  }

  @HostListener('window:resize', [])
  public onResize() {
    // console.log('resize', window.innerWidth);
    this.displayWidth.next(window.innerWidth);
    if (window.innerWidth < 991) {
      if (!this.mobileSizeService.mobileWidthBS.value) { // only change if have to
        this.mobileSizeService.mobileWidthBS.next(true);
        this.isMobile = true;

      }
    } else {
      if (this.mobileSizeService.mobileWidthBS.value) { // only change if have to
        this.mobileSizeService.mobileWidthBS.next(false);
        this.isMobile = false;

      }
    }

  }

  constructor(
    public app: LayoutComponent,
    private authService: AuthService,
    private scopeService: ScopeService,
    private mobileSizeService: MobileSizeService,
    private router: Router,
    private route: ActivatedRoute,
  ) {

  }

  ngOnInit() {
    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof Scroll) {
        // console.log(event.routerEvent.url);
        // console.log(this.isBtnActive[event.routerEvent.url]);
        Object.keys(this.isBtnActive).forEach(key => {
          this.isBtnActive[key] = false
        })

        if (!this.isBtnActive[event.routerEvent.url]) {
          this.isBtnActive[event.routerEvent.url] = true;
        }

        Object.keys(this.isAdminBtnActive).forEach(key => {
          this.isAdminBtnActive[key] = false
        })

        if (!this.isAdminBtnActive[event.routerEvent.url]) {
          this.isAdminBtnActive[event.routerEvent.url] = true;
        }
      }
    });

    this.userSub = this.authService.userDetailsObs
      .subscribe(user => {
        if (user) {
          this.activeUser = user;
        }
      });

    const combine = combineLatest([this.authService.userDetailsObs, this.scopeService.scopedUser$, this.displayWidth]);
    this.viewAsUserNameSub = combine
      .subscribe(([activeUser, scopedUser, screenWidth]) => {
        if (activeUser && scopedUser) {
          if (scopedUser.id !== activeUser.id) {
            this.viewAsUserName = scopedUser.first_name + ' ' + scopedUser.last_name;
          } else {
            this.viewAsUserName = '';
          }

          // console.log('mobile', this.isMobile);
          const userMenu: MenuItem[] = [
            { label: 'Home', icon: '/assets/v3_osto/home-icon.svg', routerLink: ['/dashboard'], },
            { label: 'Supplies', icon: '/assets/v3_osto/supplies-icon.svg', routerLink: ['/supplies'] },
            { label: 'Usage', icon: '/assets/v3_osto/usage-icon.svg', routerLink: ['/usages'], },
            { label: 'Output', icon: '/assets/v3_osto/output-icon.svg', routerLink: ['/outputs'], },
            { label: 'Suppliers', icon: '/assets/v3_osto/suppliers-icon.svg', routerLink: ['/supplies/suppliers'] },
            { label: 'Orders', icon: '/assets/v3_osto/order-icon.svg', routerLink: ['/supplies/orders'] },
            { label: 'Settings', icon: '/assets/v3_osto/setting-icon.svg', routerLink: ['/settings'] }
          ];
          this.model = [...userMenu];

          this.adminModel = [];
          if (activeUser.role === 0) { // Admin
            this.model.push(
              { label: 'Admin', icon: '/assets/v3_osto/setting-icon.svg', routerLink: ['/admin'] }
            );
            this.adminModel = [
              { label: 'Users', icon: 'pi pi-users', routerLink: ['/admin/users'] },
              { label: 'Master Supplies', icon: 'pi supplies-icon-black', routerLink: ['/admin/mastersupplies'], },
              { label: 'Master Care Provider', icon: 'pi pi-fw pi-home', routerLink: ['/admin/mastercareprovider'], },
              { label: 'Push Notifications', icon: 'pi pi-envelope', routerLink: ['/admin/pushnotifications'] },
              { label: 'Bulk Emails', icon: 'pi pi-envelope', routerLink: ['/admin/bulk-emails'] },
              { label: 'Push Topics', icon: 'terms-use-black', routerLink: ['/admin/pushtopics'] },
              { label: 'Release Notes', icon: 'terms-use-black', routerLink: ['/admin/release-notes'] },
              { label: 'Sponsors', icon: 'pi pi-cog', routerLink: ['/admin/sponsors'] },
            ]
          }

          if (screenWidth > 1250) {
            this.isMobile = false;
            this.isMobileMenuActive = false;
          } else {
            this.isMobile = true;
            // this.model = [];
          }

        }
      });
  }

  menuItemSelected(item: MenuItem) {
    // console.log(item);
    this.isMobileMenuActive = false;
    this.router.navigate([item.routerLink[0]]);
  }

  adminMenuItemSelected(item: MenuItem) {
    // console.log(item);
    this.router.navigate([item.routerLink[0]]);
  }

  showMobileMenu() {
    this.isMobileMenuActive = !this.isMobileMenuActive;
  }


  onLogout() {
    this.authService.logout();
  }


  get profileUrl() {
    if (!this.activeUser.thumb_name) {
      return this.blankImage;
    }
    if (this.activeUser.thumb_name === null) {
      return this.blankImage;
    }
    return this.activeUser.thumb_name;
  }

  onReset() {
    this.scopeService.viewAsActiveUser();
  }

  ngOnDestroy() {
    this.userSub.unsubscribe();
    if (this.viewAsUserNameSub) {
      this.viewAsUserNameSub.unsubscribe();
    }
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }
}
